"use client";

import { useEffect, useState } from "react";

/**
 * `true` once the viewport matches `query`. Starts `false` on the server and on the
 * first client render so hydration output is deterministic; the real value lands in
 * an effect. Callers must tolerate one frame of the narrow layout.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [query]);

  return matches;
}
